import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

/**
 * The publisher profiles (GET /api/publishers) for "Publish with…". `enabled: false` reads what is
 * cached without fetching: the stamp needs the list only to name a document's publisher.
 * They change only with a deploy, so they are fetched once per session.
 */
export function usePublisherProfiles({ enabled = true }: { enabled?: boolean } = {}) {
  const query = useQuery({
    queryKey: ["publishers"],
    queryFn: () => api.publishers.list(),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
  });
  return { profiles: query.data?.profiles ?? [], installed: query.data?.installed ?? {}, isLoading: query.isLoading };
}

/** The compliance dashboard's rows: always fresh, since it is opened after editing. */
export function usePublisherDocuments() {
  const query = useQuery({ queryKey: ["publisher-documents"], queryFn: () => api.publishers.documents(), staleTime: 0 });
  return { rows: query.data?.documents ?? [], limit: query.data?.limit ?? 50, isLoading: query.isLoading, isError: query.isError };
}
